import React from 'react'

import { useSelector } from 'react-redux'

import SubmissionMetrics from '@components/Submission/Metrics'
import { SubmissionChannels } from '@enums'
import hooks from '@hooks'
import { useCampaignIdFromRoute } from '@hooks/useCampaignIdFromRoute'
import { IApplicationState } from '@store'
import { selectBriefChannelPreference, selectShortlistSummaryLink } from '@store/campaigns'
import InboxTopPanelMetricsPublished from './Published/Published'
import InboxTopPanelMetricsShortlisted from './Shortlisted/Shortlisted'

const InboxTopPanelMetrics: React.FC = () => {
  const campaignId = useCampaignIdFromRoute()
  const { currentFilter } = hooks.useInboxFilter()
  const hasShortlistSummaryLink = useSelector((state: IApplicationState) =>
    Boolean(selectShortlistSummaryLink(state, campaignId)),
  )
  const channels = useSelector((state: IApplicationState) =>
    selectBriefChannelPreference(state, campaignId),
  )

  const isPinterestCampaign = channels.includes(SubmissionChannels.Pinterest)
  if (isPinterestCampaign) {
    return null
  }

  if (currentFilter === 'shortlisted') {
    if (hasShortlistSummaryLink) {
      return <InboxTopPanelMetricsShortlisted />
    }

    return <SubmissionMetrics />
  }

  return (
    <React.Fragment>
      {currentFilter === 'published' && <InboxTopPanelMetricsPublished />}
    </React.Fragment>
  )
}

export { InboxTopPanelMetrics }
export default InboxTopPanelMetrics
